<template>
  <div class="inner-menu" :class="{ 'inner-menu--open': isOpen, 'inner-menu--deep': deep }">
    <div class="inner-menu__slide">
      <div class="inner-menu__title" @click="hideCurrLevel">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.8089 4.02793L16.1406 5.35688L8.1538 13.3456L6.82298 12.0138L14.8089 4.02699V4.02793Z" fill="#CCCCCC"/>
          <path d="M16.1416 18.6692L14.8089 20L6.82395 12.0141L8.15478 10.6824L16.1416 18.6692Z" fill="#CCCCCC"/>
        </svg>
        <img v-if="title.icon" :src="title.icon" alt="">
        <div class="inner-menu__title-subtext-wrap">
          <div class="inner-menu__title-subtext-title">{{ title.text }}</div>
          <div v-if="title.subtext" class="inner-menu__title-subtext">{{ title.subtext}}</div>
        </div>
      </div>
      <div class="inner-menu__content">
        <template v-for="item in content">
          <div v-if="item.divider" class="inner-menu__content-item-divider" :key="item.key"></div>
          <div v-else class="inner-menu__content-item" :key="item.name">
            <a :href="item.full_url" @click="item.action ? item.action($event, item) : null" :class="{ 'p-e-disable': item.disablePointerEvents }">
              <img v-if="item.icon && !deep" :src="item.icon" :class="{ 'inner-menu__content-item-img--size-big': item.size }" alt="">
              <div class="inner-menu__content-item-subtitle-wrap">
                <div>{{ item.name }}</div>
                <div v-if="item.subtitle" class="inner-menu__content-item-subtitle">{{ item.subtitle }}</div>
              </div>
            </a>
            <button v-if="item.removeAction" @click="item.removeAction ? item.removeAction(item.removeUrl): null" class="inner-menu__content-item-trigger inner-menu__content-item-trigger-remove">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.88873 10L0 1.11111L1.11109 1.35669e-06L9.99982 8.88889L8.88873 10Z" fill="#909090"/>
                <path d="M0.000181322 8.88889L8.88891 0L10 1.11111L1.11127 10L0.000181322 8.88889Z" fill="#909090"/>
              </svg>
            </button>
            <button v-if="item.items && item.items.length > 0" class="inner-menu__content-item-trigger" @click="openNextLevel(item)">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.19114 2.02793L5.85938 3.35688L13.8462 11.3456L15.177 10.0138L7.19114 2.02699V2.02793Z" fill="#CCCCCC"/>
                <path d="M5.8584 16.6692L7.1911 18L15.176 10.0141L13.8452 8.68235L5.8584 16.6692Z" fill="#CCCCCC"/>
              </svg>
            </button>
          </div>
        </template>
        <button class="inner-menu__action-btn" :class="{'inner-menu__action-btn--plain': actionBtn.type === 'plain'}" v-if="actionBtn && Object.keys(actionBtn).length" @click="actionBtn.action ? actionBtn.action() : null">
          {{ actionBtn.title }}
        </button>
      </div>
    </div>
    <inner-level-menu
      v-if="innerMenuOpen"
      :deep="true"
      :title="innerMenuTitle"
      :content="innerMenuContent"
      :is-open="innerMenuOpen"
      @hideCurrLevel="hideCurrLevelAction"
    ></inner-level-menu>
  </div>
</template>

<script>
export default {
  name: 'InnerLevelMenu',
  data () {
    return {
      innerMenuTitle: {},
      innerMenuContent: [],
      innerMenuOpen: false
    }
  },
  props: {
    deep: {
      type: Boolean,
      default: false
    },
    actionBtn: {
      type: Object,
      default: () => {}
    },
    title: {
      type: Object,
      default: () => {}
    },
    content: {
      type: Array,
      default: () => []
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hideCurrLevel () {
      this.$emit('hideCurrLevel')
    },
    hideCurrLevelAction () {
      this.innerMenuOpen = false
    },
    openNextLevel (item) {
      this.innerMenuTitle = {
        text: item.name,
        icon: item.icon
      }
      this.innerMenuContent = item.items
      this.innerMenuOpen = true
    }
  }
}
</script>

<style lang="sass">
.inner-menu
  &__action-btn
    display: flex
    align-items: center
    justify-content: center
    padding: 11px 15px 13px
    margin: 18px 30px
    color: #fff
    background-color: #FF2F00
    border: none
    width: calc(100% - 60px)
    max-width: 320px
    border-radius: 3px
    font-weight: 500
    transition: all .3s
    &:hover
      background-color: #D72700
    &--plain
      background-color: #fff
      border: 1px solid #FF2F00
      color: #333
      &:hover
        background-color: #FF2F00
        color: #fff
  &__content
    padding: 10px 0
    overflow-y: auto
    &-item
      display: flex
      align-items: center
      padding: 11px 15px 11px 30px
      min-height: 40px
      font-size: 14px
      &-subtitle
        color: #359D3F
        font-size: 14px
        font-weight: 400
        margin-top: 5px
        &-wrap
          display: flex
          flex-direction: column
      a
        display: flex
        align-items: center
        margin-right: 10px
        color: #333
        flex-grow: 1
        &:hover
          color: #FF2F00
      img
        width: 20px
        height: 20px
        margin-right: 20px
        flex-shrink: 0
        &.inner-menu__content-item-img--size-big
          width: 25px
          height: 25px
      &-trigger
        width: 24px
        height: 24px
        display: flex
        align-items: center
        justify-content: center
        border: none
        background: none
        padding: 0
        flex-shrink: 0
        margin: -2px 0 -2px auto
        &-remove
          margin: -2px 10px -2px 0
</style>
<style lang="sass" scoped="">
.p-e-disable
  pointer-events: none
.inner-menu
  position: absolute
  left: 0
  top: 62px
  width: 100%
  height: calc(100% - 62px)
  pointer-events: none
  overflow: hidden
  &--deep
    top: 0
    height: 100%
  &--open
    .inner-menu__slide
      transform: translateX(0)
  &__slide
    background: #F8F8F8
    width: 100%
    height: 100%
    pointer-events: all
    transform: translateX(100%)
    transition: transform 0.3s
    display: flex
    flex-direction: column
  &__title
    padding: 15px
    display: flex
    align-items: center
    font-weight: 500
    font-size: 16px
    border-bottom: 1px solid #E7E7E7
    cursor: pointer
    &-subtext
      color: #909090
      font-size: 14px
      font-weight: 400
      margin-top: 4px
      width: 100%
      line-height: 21px
      &-title
        line-height: 24px
      &-wrap
        display: flex
        flex-direction: column
    svg
      width: 24px
      height: 24px
      margin-right: 10px
      flex-shrink: 0
    img
      width: 20px
      height: 20px
      margin-right: 15px
      flex-shrink: 0

@supports (-webkit-hyphens: none)
  @media screen and (max-width: 767px)
    .inner-menu__title-subtext-title
      margin-bottom: -2px
    .inner-menu__title-subtext
      margin-top: 6px
</style>
